module.exports = __webpack_public_path__ + "img/grondeigendom.39f071af.png";